import type { AppSingleSelectOption } from '@libs/ui';
import { AvailabilityOrder } from '@libs/trip-planner-interfaces';

import { SuggestionType } from './SuggestionTypeSelector.model';

export function getSelectedOptionForSuggestionType(
  allSuggestionTypes: AppSingleSelectOption<SuggestionType>[],
  suggestionType: SuggestionType
): AppSingleSelectOption<SuggestionType> | null {
  const result = allSuggestionTypes.find(
    (option) => option.id === suggestionType
  );

  return result || null;
}

export function mapAvailabilityOrderToSuggestionType(
  availabilityOrder: AvailabilityOrder
): SuggestionType {
  switch (availabilityOrder) {
    case AvailabilityOrder.Cheapest:
      return SuggestionType.Cheapest;

    case AvailabilityOrder.Popular:
      return SuggestionType.MostPopular;

    default:
      return SuggestionType.MostPopular;
  }
}

export function mapSuggestionTypeToAvailabilityOrder(
  suggestionType: SuggestionType
): AvailabilityOrder {
  switch (suggestionType) {
    case SuggestionType.Cheapest:
      return AvailabilityOrder.Cheapest;

    case SuggestionType.MostPopular:
      return AvailabilityOrder.Popular;

    default:
      return AvailabilityOrder.Popular;
  }
}
